export default {
  id: 'molten.numeric.Equals.ComparatorFilterConverter',
  type: 'numeric.Equals',
  convert: (cmp, attribute) => {
    if (cmp?.value1 == null) {
      return null;
    }
    return {
      type: 'equals',
      value: cmp.value1,
      field: attribute.blueprint.field,
      isDate: attribute.valueType === 'timestamp'
    };
  }
};